// src/context/CursorContext.tsx
import React, { ReactNode } from "react";
import { useState } from "react";
import { CursorContext } from "./cursorUtils";

interface CursorProviderProps {
  children: ReactNode;
}

export const CursorProvider: React.FC<CursorProviderProps> = ({ children }) => {
  const [isHovering, setIsHovering] = useState(false);
  const [isPointer, setIsPointer] = useState(false);
  const [hoverText, setHoverText] = useState("");
  const [isMorphed, setIsMorphed] = useState(false);
  const [morphStyle, setMorphStyle] = useState<{
    backgroundColor?: string;
    width?: string;
    height?: string;
    clipPath?: string;
    scale?: number;
  }>({
    backgroundColor: "#DB0703",
    width: "30px",
    height: "30px",
    clipPath: "circle(50% at 50% 50%)",
    scale: 1,
  });
  const [shapePaths, setShapePaths] = useState<string[]>([]);
  const [shapeColors, setShapeColors] = useState<string[]>([]);
  const setShape = (paths: string[], colors: string[]) => {
    setShapePaths(paths);
    setShapeColors(colors);
  };

  return (
    <CursorContext.Provider
      value={{
        isHovering,
        setIsHovering,
        isPointer,
        setIsPointer,
        hoverText,
        setHoverText,
        isMorphed,
        setIsMorphed,
        morphStyle,
        setMorphStyle,
        shapePaths,
        shapeColors,
        setShape,
      }}
    >
      {children}
    </CursorContext.Provider>
  );
};
